import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../../API/axiosNeatex';
import type { DepreciationModels } from './DepreciationModels';
import type { APIResponse } from '../../../Shared/shared';

export const addDepreciation = createAsyncThunk(
  'Depreciation/addDepreciation',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/AddFaDepreciationTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateDepreciation = createAsyncThunk(
  'Depreciation/updateDepreciation',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<any>>(
        'FATransaction/UpdateFaDepreciationTransactions',
        item
      );
      if (data?.succeeded) {
        return data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getDepreciationList = createAsyncThunk(
  'Depreciation/getDepreciationList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<DepreciationModels[]>>(
        'FATransaction/GetDepreciationList'
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getDepreciationById = createAsyncThunk(
  'Depreciation/getDepreciationById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get<APIResponse<DepreciationModels>>(
        `FATransaction/GetDepreciationById?Id=${id}`
      );
      if (data?.succeeded) {
        return data?.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getDepreciationByAssetId = createAsyncThunk(
//   'Depreciation/getDepreciationByAssetId',
//   async (AssetId: string, { rejectWithValue }) => {
//     try {
//       const { data } = await ntxAPI.get<APIResponse<DepreciationModels>>(`FA/GetDepreciationByAssetId?AssetId=${AssetId}`);
//       if (data?.succeeded) {
//         return data?.data;
//       } else {
//         return rejectWithValue(data.message);
//       }
//     } catch (error: any) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

const initialState: {
  DepreciationList: DepreciationModels[];
  DepreciationById: DepreciationModels;
  DepreciationByAssetId: DepreciationModels;
  loading: boolean;
  error: any | null;
} = {
  DepreciationList: [],
  DepreciationById: {} as DepreciationModels,
  DepreciationByAssetId: {} as DepreciationModels,
  loading: false,
  error: null
};

const DepreciationSlice = createSlice({
  name: 'Depreciation',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getDepreciationList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getDepreciationList.fulfilled,
        (state, action: PayloadAction<DepreciationModels[]>) => {
          state.loading = false;
          state.DepreciationList = action.payload;
        }
      )
      .addCase(getDepreciationList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getDepreciationById.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(
        getDepreciationById.fulfilled,
        (state, action: PayloadAction<DepreciationModels>) => {
          state.loading = false;
          state.DepreciationById = action.payload;
        }
      )
      .addCase(getDepreciationById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      });

    // .addCase(getDepreciationByAssetId.pending, (state, action) => {
    //   state.loading = true;
    // })
    // .addCase(getDepreciationByAssetId.fulfilled, (state, action: PayloadAction<DepreciationModels>) => {
    //   state.loading = false;
    //   state.DepreciationByAssetId = action.payload;
    // })
    // .addCase(getDepreciationByAssetId.rejected, (state, action: PayloadAction<any>) => {
    //   state.loading = false;
    //   state.error = action.payload;
    // })
  }
});

export default DepreciationSlice.reducer;
